<template>
  <div>
    <template v-for="{ visible, icon, header, urgent, body } in points">
      <v-expand-transition>
        <AppBanner v-if="visible" :icon>
          {{ header }}
          <strong class="ms-1">{{ body }}</strong>
          <BoltIcon v-if="urgent" end />
        </AppBanner>
      </v-expand-transition>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Product, VisaForm } from '~/types';

interface Point {
  visible: boolean;
  header: string;
  body: string;
  icon: string;
  flippedIcon?: boolean;
  urgent?: boolean;
}

const props = defineProps<{
  product: Product;
  urgency: VisaForm['urgency'];
}>();

const { tt } = useLocalization();

const waitText = computed(() => {
  if (props.urgency == 'none') return tt(`days_${props.product.wait}`);
  return tt(`priority.wait_${props.urgency}`);
});

const points = computed<Point[]>(() => {
  const { product, urgency } = props;
  return [
    {
      visible: true,
      icon: 'mdi:timetable',
      header: tt('valid_for'),
      body: tt(`product.validity.${product.validity}`)
    }, {
      visible: true,
      icon: 'mdi:timer-sand',
      header: tt('visa_ready_within'),
      body: waitText.value,
      urgent: urgency != 'none'
    }, {
      visible: true,
      icon: 'mdi:airplane-landing',
      flippedIcon: true,
      header: tt('num_entries'),
      body: tt(`product.entries.${product.entries}`)
    }, {
      visible: !!product.stay_limit,
      icon: 'mdi:calendar-end',
      header: tt('stay_limit'),
      body: tt('stay_days', { limit: product.stay_limit })
    }, {
      visible: !!product.note,
      icon: 'mdi:info-outline',
      header: product.note ? tt(product.note) : '',
      body: ''
    }
  ]
});
</script>

<style scoped>
.v-banner-text {
  padding-inline-end: 0;
}
.v-banner:last-child {
  border: none;
}
</style>